<script setup lang="ts">
  import { computed, ref } from "vue";
  import { Partner } from "@/data/actions-query";
  import GenericPartnerPanel from "./generic-partner-panel.vue";
  import _ from "lodash";
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  const collapsed = ref(true);

  const { partners } = defineProps<{
    partners: Partner[];
  }>();

  const offices = computed(() => {
    const offices = _.uniq(partners.flatMap((partner) => partner.offices?.map((office) => office.name)));
    return offices.join(", ");
  });
</script>
<template>
  <GenericPartnerPanel toggleable v-model:collapsed="collapsed" :edit_route="{ name: 'admin-partners-aceg' }">
    <template #header>
      <div class="flex items-center gap-2" @click="collapsed = !collapsed">
        <img data-src="/images/aceg.png" width="150" class="lazyload my-2" />
      </div>
    </template>
    <div class="flex flex-col gap-2">
      <div class="flex flex-col gap-1">
        <div class="text-gray-500 text-12">Bedrijf</div>
        <div class="text-14">ACEG</div>
      </div>
      <div class="flex flex-col gap-1">
        <div class="text-gray-500 text-12">Diensten</div>
        <div class="text-14">
          {{ partners.map((partner) => t(`views.partner.${partner.type}_title`)).join(", ") }}
        </div>
      </div>
      <div class="flex flex-col gap-1">
        <div class="text-gray-500 text-12">Actieve Kantoren</div>
        <div class="text-14">
          {{ offices }}
        </div>
      </div>
    </div>
  </GenericPartnerPanel>
</template>
